import AdCampaignPage from './AdCampaignPage';

export default AdCampaignPage;
